import React from 'react';
import styled from 'styled-components/macro';

const QuestionsBoxContainer = styled.div``;

const QuestionsBoxTitle = styled.div`
  margin: 1rem 0 0;
`;

const QuestionsBoxScrollingContainer = styled.div`
  background-color: #fff;
  border: 1px solid #c4c4c4;
  border-radius: 6px;
  height: 300px;
  margin: 1rem 0;
  overflow: auto;
  padding: 0.5rem 0;
`;

const SectionBreak = styled.div`
  font-weight: 600;
  padding: 0 1rem;
`;

const QLabel = styled.span`
  font-weight: 600;
`;

const FieldButton = styled.div`
  cursor: pointer;
  margin: 0.5rem 0;
  padding: 0.5rem 1rem;
  &&:hover {
    ${props =>
      props.$disabled ? 'cursor: not-allowed' : 'background-color: #edf2ff;'};
  }
`;

const QuestionsBoxView = props => {
  return (
    <QuestionsBoxContainer>
      <QuestionsBoxTitle>Questions</QuestionsBoxTitle>
      <QuestionsBoxScrollingContainer>
        {props.fields.map(field => {
          if (field.uiType === 'section_break') {
            return <SectionBreak key={field.value}>{field.text}</SectionBreak>;
          }
          return (
            <FieldButton
              key={field.value}
              $disabled={props.disableQuestions}
              onClick={() => {
                if (!props.disableQuestions) {
                  props.onClickField(field, field.qLabel);
                }
              }}
            >
              <QLabel>{field.qLabel}.</QLabel> {field.text}
            </FieldButton>
          );
        })}
      </QuestionsBoxScrollingContainer>
    </QuestionsBoxContainer>
  );
};

export default QuestionsBoxView;
